module.exports = __webpack_public_path__ + "img/snow.2f3e2df3.svg";